import {
  PhoneIncoming,
  PhoneOutgoing,
  Video,
  MoveDownLeft,
  MoveUpRight
} from 'lucide-react'
import React from 'react'
import { formatDuration } from '../../Elements/Call'

function CallingBubble({ content, isLoggedUser, CallingInitiate }) {
  // console.log(content.callData.subtype == 'call:ended')
  // console.log(content);
  return (
    <div>
      <span
        className="d-flex flex-row align-items-center justify-content-around gap-2 p-1"
        style={{
          //   backgroundColor: isLoggedUser ? '#6b6b6b' : '#bdbdbd',
          maxWidth: '200px',
          width: '100%',
          height: '40px',
          flex: '1 1 auto'
        }}
        // onClick={CallingInitiate}
      >
        <div
          //   className=" d-flex align-items-center justify-content-center bg-secondary rounded-circle"
          style={{
            borderRadius: '50%',
            width: '28px',
            height: '28px',
            borderColor: '#fff'
          }}
          className="position-relative d-flex align-items-center justify-content-center"
        >
          {isLoggedUser ? (
            <>
              {content.callType === 'Audio' && (
                <PhoneOutgoing size={20} style={{ color: '#fff' }} />
              )}
              {content.callType === 'Video' && (
                <>
                  <Video size={20} style={{ color: '#fff' }} />
                  <MoveUpRight
                    size="10"
                    style={{
                      color: '#fff',
                      position: 'absolute',
                      top: '-2px',
                      right: '-2px'
                    }}
                  />
                </>
              )}
            </>
          ) : (
            <>
              {content.callType === 'Audio' && (
                <PhoneIncoming size={20} style={{ color: 'red' }} />
              )}
              {content.callType === 'Video' && (
                <>
                  <Video size={20} style={{ color: 'red' }} />
                  <MoveDownLeft
                    size="10"
                    style={{
                      color: 'red',
                      position: 'absolute',
                      top: '-2px',
                      right: '-2px'
                    }}
                  />
                </>
              )}
            </>
          )}
        </div>

        <div className='call-content'>
          <p
            className="mt-1"
            style={{
              fontSize: '13px',
              width: 'fit-content',
              margin: '0',
              color: isLoggedUser ? '#fff' : '#000'
            }}
          >
            {content.callType}{' '}
            {Array.isArray(content?.callData) &&
              content?.callData.filter(item => item.subtype === 'call:accepted')
                .length === 0 &&
              'Missed'}{' '}
            Call
          </p>
          {content.callDuration && (
            <span
              style={{
                fontSize: '11px',
                color: isLoggedUser ? '#fff' : '#000'
              }}
            >
              {formatDuration(content.callDuration)}
            </span>
          )}
          {/* <span
            className="position-absolute s-2 b-0"
            style={{ color: isLoggedUser ? 'grey' : 'grey', fontSize: '9px' }}
          >
            {content.callStatus}
          </span> */}
        </div>
      </span>
    </div>
  )
}

export default CallingBubble
